import React from 'react';

function Showlist() {
  return (
    <>
      <section class="show-list">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-md-3 align-self-center"  style={{ backgroundColor:"#812e43", color: "#fff"}}>
                <h5>Upcoming Shows</h5>
            </div>
            <div class="col-md-3">
                <div class="item">
                    <strong> Silver Show in Jaipur</strong>
                    8-9-10 November 2025<br/>
                    <small>JECC, Sitapura, Jaipur</small>
                </div>
            </div>
            <div class="col-md-3">
                <div class="item">
                    <strong> Silver Show in Agra</strong>
                    7-8-9 September 2025<br/>
                    <small>Agra, Utter Pradesh</small>
                </div>
            </div>
            <div class="col-md-3">
            </div>
        </div>
    </div>
</section>
      </>
  )

}

export default Showlist;
